/**
 * Figma `Menu`(35:621) · `_Menu/Item`(34:340) 에서 읽은 값.
 * 메뉴 = 흰 면 + border/subtle 1px, 모서리 · 그림자 없음(D3 헤더 계정 메뉴).
 * 항목 = 높이 40, 좌우 12, 글자 body-medium 가운데 정렬 + 아래 border/subtle 1px.
 */
export const MENU_ITEM_TONES = ['default', 'danger'] as const;
export type MenuItemTone = (typeof MENU_ITEM_TONES)[number];

export const MENU_STATUSES = ['default', 'init'] as const;
export type MenuStatus = (typeof MENU_STATUSES)[number];

/**
 * 메뉴 상자. Figma 너비는 220(고정)인데 토큰이 없어 최소 너비 200(`size.button.xl`)으로 두고 내용에 맞춘다.
 * 정확한 너비는 부르는 쪽이 className 으로 준다.
 */
export const MENU_CLASS =
  'flex min-w-(--size-button-xl) flex-col border border-border-subtle bg-bg-surface';

export const MENU_ITEM_BASE_CLASS =
  'group flex h-(--size-control-md) w-full shrink-0 cursor-pointer items-center justify-center gap-2 border-b border-border-subtle px-3 whitespace-nowrap select-none typo-body-medium disabled:cursor-not-allowed disabled:text-fg-disabled';

/** 글자 색 · hover(키보드로 옮겨 온 항목도 같은 면) */
export const MENU_ITEM_TONE_CLASS: Record<MenuItemTone, string> = {
  default: 'text-fg-default enabled:hover:bg-bg-hover enabled:focus-visible:bg-bg-hover',
  danger:
    'text-fg-danger enabled:hover:bg-bg-danger-subtle enabled:focus-visible:bg-bg-danger-subtle',
};

/** 앞 아이콘 색(default 는 fg/muted, danger 는 글자와 같다) */
export const MENU_ITEM_ICON_CLASS: Record<MenuItemTone, string> = {
  default: 'text-fg-muted group-disabled:text-fg-disabled',
  danger: 'group-disabled:text-fg-disabled',
};

/** status=init 의 줄(높이 36 = 위아래 12 + 막대 12) · 막대 너비(Figma 120 · 100 · 80, `size.skeleton.*` DD-19) */
export const MENU_SKELETON_ROW_CLASS = 'flex items-center px-3 py-3';
export const MENU_SKELETON_BAR_CLASS = [
  'w-(--size-skeleton-120)',
  'w-(--size-skeleton-100)',
  'w-(--size-skeleton-80)',
] as const;

/** portal 로 띄울 때 기준 요소와의 거리(px) */
export const MENU_OFFSET_PX = 4;
